/*=============================
=       Lazy Load Images      =
=============================*/

document.addEventListener('DOMContentLoaded', function() {
	var heroImages = [].slice.call(document.querySelectorAll('#hero .bg-container, #hero video')),
		lazyImages = [].slice.call(document.querySelectorAll('main img:not(.not-lazy):not(.first), main .bg-container:not(.not-lazy):not(.first), section.statistics video, footer img')),
		active = false,
		heroLazyLoad = function() {
			heroImages.forEach(function(img) {
				imgLazyLoad(img, 300);

				heroImages = heroImages.filter(function(image) {
					return image !== img;
				});

				if(heroImages.length === 0) {
					document.removeEventListener('scroll', heroLazyLoad);
					window.removeEventListener('resize', heroLazyLoad);
					window.removeEventListener('orientationchange', heroLazyLoad);
				}
			});
		};

	// Hero Images
	setTimeout(heroLazyLoad, 1);

	// Regular Images
	var lazyLoad = function() {
		if(active === false) {
			active = true;

			setTimeout(function() {
				lazyImages.forEach(function(img) {
					if((img.getBoundingClientRect().top <= (window.innerHeight + 300) && img.getBoundingClientRect().bottom >= 0) && getComputedStyle(img).display !== 'none') {
						imgLazyLoad(img, (img.classList.contains('bg-container') ? 300 : 0));

						lazyImages = lazyImages.filter(function(image) {
							return image !== img;
						});

						if(lazyImages.length === 0) {
							document.removeEventListener('scroll', lazyLoad);
							window.removeEventListener('resize', lazyLoad);
							window.removeEventListener('orientationchange', lazyLoad);
						}
					}
				});

				active = false;
			}, 200);
		}
	};

	document.addEventListener('scroll', lazyLoad);
	window.addEventListener('resize', heroLazyLoad);
	window.addEventListener('resize', lazyLoad);
	window.addEventListener('orientationchange', heroLazyLoad);
	window.addEventListener('orientationchange', lazyLoad);
});

function imgLazyLoad(img, delay) {
	var url = img.getAttribute('data-src'+(checkWidth(768) && img.hasAttribute('data-src-mobile') ? '-mobile' : ''));

	if(img.tagName == 'IMG' || img.tagName == 'VIDEO')
		img.src = url;
	else
		img.style.backgroundImage = 'url('+url+')';

	setTimeout(function() {
		img.classList.add('loaded');
	}, (img.tagName == 'VIDEO' ? 0 : delay));
}

/*=============================
=          Site Toggle        =
=============================*/

var siteToggle = [].slice.call(document.querySelectorAll('#site-toggle a, #sidebar a, #toggle-cards a, .toggle-cards a')),
	domain = window.location.hostname;

siteToggle.forEach(function(toggle) {
	toggle.addEventListener('click', function(e) {
		if(this.dataset.home == 'doctors')
			Cookie.set('homepage', 'doctors', { expires: 30, domain: domain });
		else if(this.dataset.home == 'patients')
			Cookie.remove('homepage', { domain: domain });
	});
});

/*=============================
=         Sticky Header       =
=============================*/

window.addEventListener('load', function() {
	// Remove visibility: hidden; for CLS
	body.style = '';

	var stickyHeader = new Waypoint({
		element: hero.querySelector('.container2'),
		handler: function(direction) {
			var down = direction == 'down';

			if(down)
				body.classList.add('sticky');
			else
				body.classList.remove('sticky');
		},
		offset: header.offsetHeight
	});
});

var lastScrollTop = 0;

window.addEventListener('scroll', function() {
	if(checkWidth(480) && body.classList.contains('sticky') && topbar) {
		var st = window.pageYOffset || document.documentElement.scrollTop;

		if(st > lastScrollTop)
			topbar.classList.add('hide');
		else
			topbar.classList.remove('hide');

		lastScrollTop = st <= 0 ? 0 : st;
	}
});

/*=============================
=             Menu            =
=============================*/

var menu = document.getElementById('menu'),
	mobileMenuButton = document.getElementById('mobile-menu-button');

body.addEventListener('click', function(e) {
	checkAndCloseMenu(e.target);
});

document.addEventListener('keydown', function(e) {
	if(e.key == 'Escape')
		checkAndCloseMenu(menu);
});

function checkAndCloseMenu(e) {
	var open = openMenu(e);

	if(open) {
		closeMenu(open);
		toggleMenuBodyClass(false);
	}
}

[].slice.call(document.querySelectorAll('#cta-links button:not(.lang-button), #nav-wrap button:not(.lang-button):not(#search-button)')).forEach(function(navLink) {
	navLink.addEventListener('click', toggleMenu);
});

function toggleMenu() {
	closeMenu(openMenu(this));

	var parent = this.parentNode.parentNode,
		openSibling = parent.querySelector('.open'),
		isOpen = this.classList.contains('open'),
		animation = checkWidth(1200) ? (isOpen ? 'slideUp' : 'slideDown') : (isOpen ? 'fadeOut' : 'fadeIn'),
		display = isOpen ? 'none' : (this == mobileMenuButton ? 'flex' : 'block'),
		submenu = this.nextElementSibling;

	if(parent.classList.contains('submenu') && openSibling && openSibling != this)
		closeMenu(openSibling);

	Velocity(submenu, animation, {duration: 300, display: display});

	this.classList.toggle('open');

	this.setAttribute('aria-expanded', (this.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

	submenu.setAttribute('aria-hidden', (submenu.getAttribute('aria-hidden') == 'true' ? 'false' : 'true'));

	toggleMenuBodyClass(header.querySelector('.open'));
}

function closeMenu(el) {
	if(el && !el.classList.contains('language-picker-container')) {
		var submenu = el.nextElementSibling;

		Velocity(submenu, checkWidth(1200) ? 'slideUp' : 'fadeOut', {duration: 300});

		el.classList.remove('open');

		el.setAttribute('aria-expanded', 'false');

		submenu.setAttribute('aria-hidden', 'true');

		closeMenu(submenu.querySelector('.open'));
	}
}

function openMenu(el) {
	var openButton = header.querySelector('.open:not(#mobile-menu-button)');

	return openButton && !openButton.parentNode.contains(el) ? openButton : false;
}

function toggleMenuBodyClass(open) {
	if(open)
		body.classList.add('menu-open');
	else
		body.classList.remove('menu-open');

	setFocus((open ? true : false), header);
}

window.setFocus = function setFocus(open, container) {
	[].slice.call(document.querySelectorAll('#header, #hero, #main, #footer')).forEach(function(parent) {
		if(parent != container) {
			parent.setAttribute('aria-hidden', open);

			[].slice.call(parent.querySelectorAll('a, button, input')).forEach(function(link) {
				if(open)
					link.setAttribute('tabindex', '-1');
				else
					link.removeAttribute('tabindex');
			});
		}
	});
};

/*=============================
=        Skip to Content      =
=============================*/

[].slice.call(document.querySelectorAll('.skip-link')).forEach(function(skipLink) {
	skipLink.addEventListener('click', function(e) {
		e.preventDefault();

		var selectors = {
				'#menu': '#menu > li > *:first-child',
				'#main': '#hero a, main a',
				'#footer': '#footer a'
			},
			firstLink = document.querySelector(selectors[this.getAttribute('href')]);

		if(firstLink) {
			scrollToElement(firstLink);
			firstLink.focus();
		}
	});
});

window.skipLinkToggleDisplay = function skipLinkToggleDisplay(hide) {
	[].slice.call(document.querySelectorAll('.skip-link')).forEach(function(skipLink) {
		skipLink.style.display = hide ? 'none' : '';
	});
};

/*=============================
=        Scroll To Link       =
=============================*/

var scrollLinks = [].slice.call(document.querySelectorAll('.scroll-link'));

scrollLinks.forEach(function(scrollLink) {
	scrollLink.addEventListener('click', function(e) {
		if(this.tagName == 'A')
			e.preventDefault();

		scrollToElement(document.querySelector(this.getAttribute('href')));
	});
});

var sectionId = window.location.hash,
	section = sectionId ? document.querySelector(sectionId) : false;

if(section) {
	setTimeout(function() {
		scrollToElement(section);
	}, 300);

	if(section.parentNode.classList.contains('accordion')) {
		setTimeout(function() {
			var button = section.querySelector('button'),
				answer = section.querySelector('.answer');

			Velocity(answer, 'slideDown', {duration: 250});

			button.classList.add('open');

			button.setAttribute('aria-expanded', 'true');

			answer.setAttribute('aria-hidden', 'false');
		}, 1200);
	}
}

/*=============================
=         Element Link        =
=============================*/

var links = [].slice.call(document.querySelectorAll('.link'));

links.forEach(function(link) {
	link.addEventListener('click', function(e) {
		if(e.target.tagName !== 'A' && this.hasAttribute('data-href')) {
			var href = this.dataset.href;

			if(href.indexOf(location.host) == -1)
				window.open(href);
			else
				window.location.href = href;
		}
	});
});

/*=============================
=        Announcements        =
=============================*/

if(announcementsContainer) {
	var announcementButtons = [].slice.call(announcementsContainer.querySelectorAll('.controller button')),
		firstAnnouncement = announcementsContainer.querySelector('li:first-child'),
		lastAnnouncement = announcementsContainer.querySelector('li:last-child'),
		autoSlide = function() {
			slideAnnouncement();
		};

	if(announcementButtons.length)
		var intervalID = setInterval(autoSlide, 15000);

	announcementButtons.forEach(function(button) {
		button.addEventListener('click', function() {
			clearInterval(intervalID);

			if(this.classList.contains('next')) {
				slideAnnouncement();

				if(this.previousSibling.classList.contains('pause'))
					intervalID = setInterval(autoSlide, 15000);
			}
			else {
				var isPlay = this.classList.contains('play');

				if(isPlay)
					intervalID = setInterval(autoSlide, 15000);

				this.className = isPlay ? 'pause' : 'play';
				this.setAttribute('aria-label', (isPlay ? 'Pause' : 'Play')+' Announcements');
			}
		});
	});

	announcementsContainer.querySelector('.close').addEventListener('click', function() {
		announcementsContainer.classList.toggle('closed');

		var isClosed = announcementsContainer.classList.contains('closed');

		if(isClosed)
			Cookie.set('announcements', 'closed', {domain: domain});
		else
			Cookie.remove('announcements', {domain: domain});

		this.setAttribute('aria-label', (isClosed ? 'Open' : 'Close') + ' Announcements');
	});
}

function slideAnnouncement() {
	var current = document.querySelector('#announcements .current'),
		sibling = current == lastAnnouncement ? firstAnnouncement : current.nextSibling;

	current.classList.add('hide');

	setTimeout(function() {
		current.className = '';
		sibling.classList.add('current', 'next');
	}, 550);
}

/*=============================
=          Accordion          =
=============================*/

var accordions = [].slice.call(document.querySelectorAll('.accordion button'));

accordions.forEach(function(accordion) {
	accordion.addEventListener('click', function() {
		var answer = this.nextSibling,
			animation = window.getComputedStyle(answer).display == 'block' ? 'slideUp' : 'slideDown';

		closeAccordion(this);

		Velocity(answer, animation, {duration: 250});

		this.classList.toggle('open');

		this.setAttribute('aria-expanded', (this.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

		answer.setAttribute('aria-hidden', (answer.getAttribute('aria-hidden') == 'true' ? 'false' : 'true'));

		// setTimeout(function() {
		// 	scrollToElement(this.parentNode);
		// }, 250);
	});
});

function closeAccordion(el) {
	var openAccordion = el.parentElement.parentElement.querySelector('.open');

	if(openAccordion && openAccordion !== el) {
		var answer = openAccordion.nextElementSibling;

		Velocity(answer, 'slideUp', {duration: 250});

		openAccordion.classList.toggle('open');

		openAccordion.setAttribute('aria-expanded', 'false');

		answer.setAttribute('aria-hidden', 'true');
	}
}

/*=============================
=       Google Translate      =
=============================*/

var languageSwitchers = [].slice.call(document.querySelectorAll('.lang-button'));

languageSwitchers.forEach(function(switcher) {
	switcher.addEventListener('click', function(e) {
		var parent = this.parentNode,
			list = parent.querySelector('ul');

		closeDropDown(parent, e);

		parent.classList.toggle('open');

		this.setAttribute('aria-expanded', (this.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

		list.setAttribute('aria-hidden', (list.getAttribute('aria-hidden') == 'true' ? 'false' : 'true'));

		Velocity(list, (window.getComputedStyle(list).display == 'block' ? 'slideUp' : 'slideDown'), {duration: 150});
	});
});

body.addEventListener('click', function(e) {
	closeDropDown(this, e);
});

function closeDropDown(el, e) {
	var open = document.querySelector('.language-picker-container.open');

	if(open && open !== el && !open.contains(e.target)) {
		var list = open.querySelector('ul');

		open.classList.remove('open');

		open.querySelector('.lang-button').setAttribute('aria-expanded', 'false');

		list.setAttribute('aria-hidden', 'true');

		Velocity(list, 'slideUp', {duration: 150});
	}
}

var languages = [].slice.call(document.querySelectorAll('.language-picker-container a[href="#"], .language-switcher-button'));

languages.forEach(function(language) {
	language.addEventListener('click', function(e) {
		e.preventDefault();

		var lang = this.getAttribute('hreflang');

		if(Cookie.get('language') !== lang) {
			googTransHandle(false, lang);

			var splitDomain = location.host.split('.');

			if(splitDomain.length >= 2)
				googTransHandle(location.host.replace(splitDomain[0]+(splitDomain.length == 2 ? splitDomain[1] : ''), ''), lang);

			window.location.reload();
		}
	});
});

function googTransHandle(domain, lang) {
	if(!domain) {
		if(typeof Cookie.get('googtrans')!=='undefined') {
			Cookie.remove('language');
			Cookie.remove('googtrans');
		}
		if(lang!=='en') {
			Cookie.set('language', lang);
			Cookie.set('googtrans', '/en/'+lang);
		}
	} else {
		if(typeof Cookie.get('googtrans', {domain: domain})!=='undefined') {
			Cookie.remove('language', {domain: domain});
			Cookie.remove('googtrans', {domain: domain});
		}
		if(lang!=='en') {
			Cookie.set('language', lang, {domain: domain});
			Cookie.set('googtrans', '/en/'+lang, {domain: domain});
		}
	}
}

/*=============================
=             Modal           =
=============================*/

var modals = [].slice.call(document.querySelectorAll('div[role="dialog"]:not(.gm-style-iw):not(#popunder)')),
	mainModal = document.getElementById('modal');

modals.forEach(function(modal) {
	modal.addEventListener('click', function(e) {
		if(e.target == modal.querySelector('.close-modal') || (modal != searchModal && !modal.querySelector('.content').contains(e.target)))
			closeModal();
	});
});

function closeModal() {
	modals.forEach(function(modal) {
		if(window.getComputedStyle(modal).display == 'block') {
			Velocity(modal, {opacity: [0,1]}, {duration: 300, display: 'none'});
			modal.setAttribute('aria-hidden', 'true');
		}

		if(modal == videoModal) {
			setTimeout(function() {
				if(videoModalElement) {
					videoModalElement.remove();
				}

				skipLinkToggleDisplay(false);
				setFocus(false, false);

				if(typeof videoModalButton !== 'undefined')
					videoModalButton.focus();
			}, 300);
		}
	});
}

document.addEventListener('keydown', function(e) {
	if(e.key == 'Escape')
		closeModal();
});

if(mainModal) {
	setTimeout(function() {
		Velocity(mainModal, {opacity: [1,0]}, {duration: 300, display: 'block'});
		mainModal.querySelector('.close-modal').focus();
		skipLinkToggleDisplay(true);
		setFocus(true, false);
	}, 10000);
}

/*=============================
=            Search           =
=============================*/

var searchButton = document.getElementById('search-button'),
	searchModal = document.getElementById('search-modal');

if(searchButton && searchModal) {
	searchButton.addEventListener('click', function() {
		Velocity(searchModal, {opacity: [1,0]}, {duration: 300, display: 'block'});

		setTimeout(function() {
			searchModal.setAttribute('aria-hidden', 'false');
			searchModal.querySelector('input').focus();
		}, 300);
	});
}

[].slice.call(document.querySelectorAll('form.search')).forEach(function(form) {
	form.addEventListener('submit', function(e) {
		e.preventDefault();

		var searchInput = this.querySelector('input');

		if(searchInput.value === '')
			searchInput.classList.add('error');
		else
			this.submit();
	});
});

/*=============================
=             Video           =
=============================*/

[].slice.call(document.querySelectorAll('.video-container button')).forEach(function(videoButton) {
	videoButton.addEventListener('click', function() {
		var parent = this.parentNode.parentNode,
			thumbnail = parent.querySelector('.thumbnail'),
			video = parent.querySelector('figure.video > *:first-child');

		if(thumbnail)
			Velocity(thumbnail, {opacity: [0,1]}, {duration: 150, display: 'none'});

		playVideo(video);
	});
});

function playVideo(video) {
	video.src = video.dataset.src;

	if(video.tagName === 'VIDEO')
		video.autoplay = true;
}

function resetVideo(video) {
	var src = video.src;

	video.src = src.replace('?autoplay=1&rel=0', '');
}

/*=============================
=     Google Map Waypoint     =
=============================*/

var locationMaps = [].slice.call(document.querySelectorAll('.map-container'));

if(locationMaps.length) {
	window.initMap = function() {
		locationMaps.forEach(function(mapElement) {
			initMap(mapElement);
		});
	};

	scriptWaypoint(locationMaps[0], 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBHstjtNYCN7uqS07XRW87TyDi8lnULunI&callback=initMap', '150%');
}

function initMap(mapElement) {
	var openWindow,
		currentMarker,
		pin = '/assets/images/icons/map-pin.svg',
		currentPin = '/assets/images/icons/map-pin-current.svg';

	axios.get('/map-section/'+mapElement.getAttribute('data-location')).then(function(r) {
		var locations = r.data.locations,
			center = JSON.parse('['+r.data.center+']'),
			mapOptions = {
				zoom: r.data.zoom,
				streetViewControl: false, // hide the yellow Street View pegman
				scaleControl: true, // allow users to zoom the Google Map
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				scrollwheel: false,
				center: new google.maps.LatLng(center[0], center[1]),
				styles: mapStyles
			};

		map = new google.maps.Map(mapElement, mapOptions);

		locations.forEach(function(location) {
			var isLocationPage = location.openWindow,
				coordinates = JSON.parse('['+location.coordinates+']'),
				latLng = new google.maps.LatLng(coordinates[0], coordinates[1]),
				infowindow = new google.maps.InfoWindow({
					position: latLng,
					content: location.html
				}),
				marker = new google.maps.Marker({
					map: map,
					position: latLng,
					draggable: false,
					animation: google.maps.Animation.DROP,
					icon: pin
				});

			if(!openWindow && !checkWidth(768)) {
				infowindow.open(map, marker); // Remove this to close infowindow by default
				openWindow = infowindow;

				marker.setIcon(currentPin);
				currentMarker = marker;
			}

			infowindow.addListener('closeclick', function() {
				openWindow = false;
				currentMarker.setIcon(pin);
			});

			marker.addListener('click', function() {
				if(currentMarker)
					currentMarker.setIcon(pin);

				if(openWindow)
					openWindow.close();

				if(currentMarker != marker) {
					marker.setIcon(currentPin);
					currentMarker = marker;

					infowindow.open(map, marker);
					openWindow = infowindow;
				}
				else {
					openWindow = false;
					currentMarker = false;
				}
			});
		});
	});
}

/*=============================
=           Popunder          =
=============================*/

var popunder = document.getElementById('popunder');

if(popunder && !popunder.classList.contains('minimize'))
	popunder.querySelector('button').focus();

[].slice.call(document.querySelectorAll('#popunder, #popunder button, #popunder a')).forEach(function(button) {
	button.addEventListener('click', function(e) {
		if(this.tagName == 'BUTTON' || this.tagName == 'A' || !document.querySelector('#popunder > div').contains(e.target)) {
			if(popunder.classList.contains('minimize')) {
				popunder.classList.remove('minimize');
				Cookie.remove('popunder', {domain: domain});
			}
			else {
				popunder.classList.add('minimize');
				Cookie.set('popunder', 'minimize', {expires: 3, domain: domain});
			}
		}
	});
});

/*=============================
=       Footer Accordion      =
=============================*/

var footerAccordion = [].slice.call(footer.querySelectorAll('#footer-two button'));

footerAccordion.forEach(function(location) {
	location.addEventListener('click', function() {
		var details = this.nextSibling;

		this.classList.toggle('open');

		Velocity(details, window.getComputedStyle(details).display == 'block' ? 'slideUp' : 'slideDown', {duration: 250});

		this.setAttribute('aria-expanded', (this.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

		details.setAttribute('aria-hidden', (details.getAttribute('aria-hidden') == 'true' ? 'false' : 'true'));
	});
});

/*=============================
=      Load 3rd Party JS      =
=============================*/

// window.addEventListener('load', function() {
// 	var js = [
// 		''
// 	];

// 	js.forEach(function(src) {
// 		addJS(src);
// 	});
// });